<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close :loading="loading">
			<template #default>
				<vxe-grid ref="bankaccountdailyList" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
				<staff-modal :islist="true" :multiple="true" ref="staffModal" @submit="stafffsubmit" />	
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import staffModal from '@_system/components/formcomponents/common/select/staff/modal/staff.vue'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				loading:false,
				modal_model: false,
				modal_title: '日对账',
				modal_width: 1000,
				modal_height: 600,
				list_formConfig: [{
						field: 'acc_name',
						title: '账户名称',
						itemRender: {
							name: '$input'
						}
					},
					{
						field: 'iscaizi',
						title: '财资账号',
						itemRender: {
							name: '$select',
							props:{
								emptyoption:false,
								selectoptions:[{
									value:1,
									label:'是'
								},{
									value:0,
									label:'否'
								}],
								type:'date',
							}
						}
					},
					{
						field: 'time',
						title: '日期',
						resetValue:this.$Moment().subtract(1, 'days').startOf('day').valueOf(),
						itemRender: {
							defaultValue:this.$Moment().subtract(1, 'days').startOf('day').valueOf(),
							name: '$datePicker',
							props:{
								type:'date'
							}
						}
					}
				],
				list_columns: [{
						type: 'seq',
						title: '#',
						width:50,
					},{
						field: 'acc_code',
						title: '账户编码',
					},
					{
						field: 'acc_name',
						title: '账户名称',
					},
					{
						field: 'inst_account',
						title: '账号'
					},
					{
						field: 'wlnsum',
						title: '万里牛余额',
					},
					{
						field: 'czsum',
						title: '财资余额',
					},
					{
						field: 'jindiesum',
						title: '金蝶余额',
					},
					{
						field: 'iscaizi',
						title: '财资账号',
						formatter: ({row})=>{
							return row.iscaizi == 1?'是':'否'
						}
					},
					{
						field: 'accountuses',
						title: '账户用途',
						formatter:'accountuses'
					},
					{
						field: 'time',
						title: '日期',
						formatter: 'date'
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 130,
						slots: {
							default: ({row}) => {
								return [<el-button type = "text" size = "mini" onClick = {() => {this.recordremain(row)}}>统计余额</el-button>]
							}
						}
					}					
				]
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			stafffsubmit(e){
				console.log(e)
				let date = this.$refs.bankaccountdailyList.getProxyInfo().form.time
				let staffs = e.data.map((item)=>{
					return item.id
				})
				if(!staffs.length){
					this.$message.error('请选择人员')
					return
				}
				this.loading = true
				this.$api.bankaccount.send({
						date:date/1000,
						staffs:staffs,
					}).then(() => {
					this.loading = false
					this.$message({
						message: '操作成功',
						type: 'success'
					})
					this.customreload()
				},()=>{
					this.loading = false
				})				
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.toolbarConfig.buttons = [{
					name: '导出',
					status: 'success',
					code: 'export'
				},{
					name: '统计余额',
					status: 'primary',
					code: 'recordremain'
				},{
					name: '发送',
					status: 'danger',
					code: 'send'
				}]
				gridOptions.formConfig.span = 6
			},
			list(page,updateForm,other) {
				return new Promise((resolve) => {
					this.$api.bankaccount.listhistorysum({
						...page,
						...updateForm,
						...other
					}).then((res) => {
						resolve(res)
					})
				})
			},
			send(){
				this.$refs.staffModal.modal_show()
				// let date = this.$refs.bankaccountdailyList.getProxyInfo().form.time
				// this.$confirm('是否确认发送', '提示', {
				// 	confirmButtonText: '确定',
				// 	cancelButtonText: '取消',
				// 	type: 'warning'
				// }).then(() => {
				// 	this.loading = true
				// 	this.$api.bankaccount.send({date:date/1000}).then(() => {
				// 		this.loading = false
				// 		this.$message({
				// 			message: '操作成功',
				// 			type: 'success'
				// 		})
				// 		this.customreload()
				// 	},()=>{
				// 		this.loading = false
				// 	})
				// }).catch(() => {
				// 	this.loading = false
				// })
			},
			recordremain(row = null){
				let time = this.$refs.bankaccountdailyList.getProxyInfo().form.time
				if(!time){
					this.$message.error('请选择时间')
					return
				}
				this.loading = true
				this.$api.bankaccount.recordremain({
					time:time,
					acc_uid:row ? row.acc_uid : null
				}).then(() => {
					this.loading = false
					this.$refs.bankaccountdailyList.commitProxy('query')
				},()=>{
					this.loading = false
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			staffModal
		}
	}
</script>